import {
  FETCH_LIBRARY_CARDS_SUCCESS,
  CREATE_LIBRARY_CARD_SUCCESS,
  UPDATE_LIBRARY_CARD_SUCCESS,
  DELETE_LIBRARY_CARD_SUCCESS,
  PRESIGNED_URL_SUCCESS,
  UPLOAD_FILE_SUCCESS,
  FETCH_METADATA_SUCCESS,
  LIST_CARDS_SUCCESS,
  FETCH_CARD_DETAILS_SUCCESS,
  GET_LIBRARY_CARD_TAGS_SUCCESS,
  GET_LIBRARY_CARD_TAGS_FAILURE,
  LIST_ENTITY_CARDS_REQUEST,
  LIST_ENTITY_CARDS_SUCCESS,
  LIST_ENTITY_CARDS_FAILURE,
  SET_SELECTED_SEARCH_SESSION,
  FETCH_LG_COLLECTION_REQUEST,
  FETCH_LG_COLLECTION_SUCCESS,
  FETCH_LG_COLLECTION_FAILURE,
  CLEAR_LG_COLLECTION_DATA,
} from "../actions/libraryCardActions";

const initialState = {
  libraryCards: [], // Array of library cards
  presignedUrls: [], // Array of presigned URLs
  fileUploadResponse: null, // Response for uploaded files
  metadata: null, // Metadata for a library card
  cardDetails: null, // Detailed information for a specific library card
  listCards: [], // List of library cards for a tenant/entity type (legacy)
  libraryCardTags: [], // Tags for library cards
  // New structure for multiple entity types
  entityLists: {
    AGENTDASHBOARD: [],
    LGSEARCHCRITERIAAPOLLO: [],
    AGENTCONFIG: [],
    N8NWORKFLOW: [],
  },
  loading: {
    AGENTDASHBOARD: false,
    LGSEARCHCRITERIAAPOLLO: false,
    AGENTCONFIG: false,
    N8NWORKFLOW: false,
  },
  // LG Collection data for the selected search session
  lgCollectionData: {
    LGSEARCHCRITERIAAPOLLO: null,
    LGAPOLLOMGR: null,
    LGENRICHMENTRESULT: null,
    LGLEADSFOUND: null,
    LGRESPONSERESULT: null,
    LGSCORINGRESULT: null,
    LGVALIDATIONRESULT: null,
  },
  lgCollectionLoading: {
    LGSEARCHCRITERIAAPOLLO: false,
    LGAPOLLOMGR: false,
    LGENRICHMENTRESULT: false,
    LGLEADSFOUND: false,
    LGRESPONSERESULT: false,
    LGSCORINGRESULT: false,
    LGVALIDATIONRESULT: false,
  },
  selectedSearchSession: null, // Currently selected search session ID
  error: null,
};

const libraryCardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LIBRARY_CARDS_SUCCESS:
      return {
        ...state,
        libraryCards: action.payload,
      };

    case CREATE_LIBRARY_CARD_SUCCESS:
      return {
        ...state,
        libraryCards: [...state.libraryCards, action.payload],
      };

    case UPDATE_LIBRARY_CARD_SUCCESS:
      return {
        ...state,
        libraryCards: state.libraryCards.map((card) =>
          card.entityId === action.payload.entityId ? action.payload : card
        ),
      };

    case DELETE_LIBRARY_CARD_SUCCESS:
      return {
        ...state,
        libraryCards: state.libraryCards.filter(
          (card) => card.entityId !== action.payload.entityId
        ),
      };

    case PRESIGNED_URL_SUCCESS:
      return {
        ...state,
        presignedUrls: action.payload,
      };

    case UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        fileUploadResponse: action.payload,
      };

    case FETCH_METADATA_SUCCESS:
      return {
        ...state,
        metadata: action.payload,
      };

    case LIST_CARDS_SUCCESS:
      return {
        ...state,
        listCards: action.payload.pageNames || action.payload,
      };

    case FETCH_CARD_DETAILS_SUCCESS:
      return {
        ...state,
        cardDetails: action.payload,
      };

    case GET_LIBRARY_CARD_TAGS_SUCCESS:
      return {
        ...state,
        libraryCardTags: action.payload.tags,
      };

    case GET_LIBRARY_CARD_TAGS_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case LIST_ENTITY_CARDS_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.entityType]: true,
        },
      };

    case LIST_ENTITY_CARDS_SUCCESS:
      const entityData =
        action.payload.data.pageNames || action.payload.data || [];
      return {
        ...state,
        entityLists: {
          ...state.entityLists,
          [action.payload.entityType]: entityData,
        },
        loading: {
          ...state.loading,
          [action.payload.entityType]: false,
        },
      };

    case LIST_ENTITY_CARDS_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.entityType]: false,
        },
        error: action.payload.error,
      };

    // LG Collection cases
    case SET_SELECTED_SEARCH_SESSION:
      return {
        ...state,
        selectedSearchSession: action.payload,
      };

    case FETCH_LG_COLLECTION_REQUEST:
      return {
        ...state,
        lgCollectionLoading: {
          ...state.lgCollectionLoading,
          [action.payload.collectionType]: true,
        },
      };

    case FETCH_LG_COLLECTION_SUCCESS:
      return {
        ...state,
        lgCollectionData: {
          ...state.lgCollectionData,
          [action.payload.collectionType]: action.payload.data,
        },
        lgCollectionLoading: {
          ...state.lgCollectionLoading,
          [action.payload.collectionType]: false,
        },
      };

    case FETCH_LG_COLLECTION_FAILURE:
      return {
        ...state,
        lgCollectionLoading: {
          ...state.lgCollectionLoading,
          [action.payload.collectionType]: false,
        },
        error: action.payload.error,
      };

    case CLEAR_LG_COLLECTION_DATA:
      return {
        ...state,
        lgCollectionData: {
          LGSEARCHCRITERIAAPOLLO: null,
          LGAPOLLOMGR: null,
          LGENRICHMENTRESULT: null,
          LGLEADSFOUND: null,
          LGRESPONSERESULT: null,
          LGSCORINGRESULT: null,
          LGVALIDATIONRESULT: null,
        },
        lgCollectionLoading: {
          LGSEARCHCRITERIAAPOLLO: false,
          LGAPOLLOMGR: false,
          LGENRICHMENTRESULT: false,
          LGLEADSFOUND: false,
          LGRESPONSERESULT: false,
          LGSCORINGRESULT: false,
          LGVALIDATIONRESULT: false,
        },
        selectedSearchSession: null,
      };

    default:
      return state;
  }
};

export default libraryCardReducer;
